<template>
  <el-checkbox-group v-model="computedValue" :disabled="!editable">
    <div
      v-for="item in config.options"
      :key="item.baseQuestionOptionId"
      class="radio-item-wrap"
    >
      <el-checkbox :label="String(item.baseQuestionOptionId)">{{
        item.baseQuestionOptionName
      }}</el-checkbox>
    </div>
  </el-checkbox-group>
</template>

<script>
import CompMix from "../../mixins/comp-mix";
export default {
  mixins: [CompMix],
  props: {
    // v-model传入的值
    value: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-item-wrap {
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0;
  }
}
::v-deep .el-checkbox {
  display: flex;
  align-items: center;
  white-space: break-spaces;
}
</style>
